/**
 * Trailing (moving) averages for a bucketed series. Pure, so the leads page's
 * trend lines are unit-tested without rendering.
 */

/**
 * The trailing mean over the previous `window` buckets, inclusive of the
 * current one; null until a full window is available, so the line never
 * pretends to know a trend it does not have.
 *
 * @param values - Bucket values in time order.
 * @param window - Buckets per average (≥ 1).
 * @returns One entry per input value.
 */
export function trailingAverage(values: readonly number[], window: number): (number | null)[] {
  const size = Math.max(1, Math.floor(window));
  let sum = 0;
  return values.map((value, index) => {
    sum += value;
    if (index >= size) sum -= values[index - size]!;
    return index + 1 >= size ? Math.round((sum / size) * 100) / 100 : null;
  });
}
